import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../public/media/blank.png'


const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { hidden: "" }
const _hoisted_3 = { class: "fv-row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-4 mt-3 mb-10 margen" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Perfíl de frente:", -1)
const _hoisted_7 = { class: "cuadrado" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  src: _imports_0,
  class: "img-fluid img-thumbnail cuadrado",
  width: "250",
  height: "250",
  alt: "without_image"
}
const _hoisted_10 = {
  key: 4,
  class: "center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  title: "Abrir camara",
  style: {"font-size":"1em","color":"Mediumslateblue"},
  class: "fas fa-lock-open"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Abrir ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  title: "Abrir camara",
  style: {"font-size":"1em","color":"Mediumslateblue"},
  class: "fas fa-lock"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Cerrar ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", {
  title: "tomar foto",
  style: {"font-size":"1.5em","color":"Dodgerblue"},
  class: "fas fa-camera"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Tomar foto ")
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 5,
  class: "center"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", {
  title: "tomar foto",
  style: {"font-size":"1.5em","color":"red"},
  class: "fas fa-trash"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Borrar ")
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "col-md-4 mt-4 mb-10 margen" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Perfíl derecha:", -1)
const _hoisted_27 = { class: "cuadrado" }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 4,
  class: "center"
}
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", {
  title: "Abrir camara",
  style: {"font-size":"1em","color":"Mediumslateblue"},
  class: "fas fa-lock-open"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Abrir ")
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  title: "Abrir camara",
  style: {"font-size":"1em","color":"Mediumslateblue"},
  class: "fas fa-lock"
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Cerrar ")
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", {
  title: "tomar foto",
  style: {"font-size":"1.5em","color":"Dodgerblue"},
  class: "fas fa-camera"
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Tomar foto ")
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = {
  key: 5,
  class: "center"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", {
  title: "tomar foto",
  style: {"font-size":"1.5em","color":"red"},
  class: "fas fa-trash"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Borrar ")
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = { class: "col-md-4 mt-3 mb-10 margen" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Perfíl izquierdo:", -1)
const _hoisted_47 = { class: "cuadrado" }
const _hoisted_48 = ["src"]
const _hoisted_49 = {
  key: 4,
  class: "center"
}
const _hoisted_50 = ["disabled"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", {
  title: "Abrir camara",
  style: {"font-size":"1em","color":"Mediumslateblue"},
  class: "fas fa-lock-open"
}, null, -1)
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Abrir ")
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", {
  title: "Abrir camara",
  style: {"font-size":"1em","color":"Mediumslateblue"},
  class: "fas fa-lock"
}, null, -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Cerrar ")
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", {
  title: "tomar foto",
  style: {"font-size":"1.5em","color":"Dodgerblue"},
  class: "fas fa-camera"
}, null, -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Tomar foto ")
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = {
  key: 5,
  class: "center"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("i", {
  title: "tomar foto",
  style: {"font-size":"1.5em","color":"red"},
  class: "fas fa-trash"
}, null, -1)
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Borrar ")
const _hoisted_64 = [
  _hoisted_62,
  _hoisted_63
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_camera = _resolveComponent("camera")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.dataEdit.state), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Field, {
            name: "frente",
            modelValue: _ctx.formData.frente,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.frente) = $event))
          }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("div", _hoisted_7, [
                (!_ctx.formData.frente && _ctx.cameraFrontal)
                  ? (_openBlock(), _createBlock(_component_camera, {
                      key: 0,
                      resolution: { width: 300, height: 300 },
                      autoplay: "",
                      ref: "camera"
                    }, null, 512))
                  : (_ctx.formData.frente)
                    ? (_openBlock(), _createElementBlock("img", _mergeProps({ key: 1 }, field, {
                        src: _ctx.formData.frente,
                        class: "img-fluid img-thumbnail cuadrado",
                        width: "250",
                        height: "250",
                        alt: "frente"
                      }), null, 16, _hoisted_8))
                    : (_openBlock(), _createElementBlock("img", _hoisted_9)),
                _createVNode(_component_ErrorMessage, {
                  name: "frente",
                  class: "fv-plugins-message-container invalid-feedback"
                }),
                (!_ctx.cameraFrontal)
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 3,
                      type: "file",
                      accept: "image/*",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
                    }, null, 32))
                  : _createCommentVNode("", true),
                (!_ctx.formData.frente)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (!_ctx.cameraFrontal)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn px-3",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openCamera()))
                          }, _hoisted_13))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn px-3",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCamera()))
                          }, _hoisted_16)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn px-3",
                        disabled: !_ctx.cameraFrontal,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.snapshot()))
                      }, _hoisted_20, 8, _hoisted_17)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn px-3",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deletesnapshot()))
                      }, _hoisted_24)
                    ]))
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode(_component_Field, {
            name: "derecha",
            modelValue: _ctx.formData.derecha,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.derecha) = $event))
          }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("div", _hoisted_27, [
                (!_ctx.formData.derecha && _ctx.cameraDerecha)
                  ? (_openBlock(), _createBlock(_component_camera, {
                      key: 0,
                      resolution: { width: 300, height: 300 },
                      autoplay: "",
                      ref: "camera"
                    }, null, 512))
                  : (_ctx.formData.derecha)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _ctx.formData.derecha,
                        class: "img-fluid img-thumbnail cuadrado",
                        width: "250",
                        height: "250",
                        alt: "derecho"
                      }, null, 8, _hoisted_28))
                    : (_openBlock(), _createElementBlock("img", _mergeProps({ key: 2 }, field, {
                        src: _imports_0,
                        class: "img-fluid img-thumbnail cuadrado",
                        width: "250",
                        height: "250",
                        alt: "without_image"
                      }), null, 16)),
                _createVNode(_component_ErrorMessage, {
                  name: "derecha",
                  class: "fv-plugins-message-container invalid-feedback"
                }),
                (_ctx.formData.frente && !_ctx.cameraDerecha)
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 3,
                      type: "file",
                      accept: "image/*",
                      onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFileChangeDerecha && _ctx.onFileChangeDerecha(...args)))
                    }, null, 32))
                  : _createCommentVNode("", true),
                (!_ctx.formData.derecha)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      (!_ctx.cameraDerecha)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn px-3",
                            disabled: !_ctx.formData.frente,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openCameraDerecha()))
                          }, _hoisted_33, 8, _hoisted_30))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn px-3",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openCameraDerecha()))
                          }, _hoisted_36)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn px-3",
                        disabled: !_ctx.cameraDerecha,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.snapshot()))
                      }, _hoisted_40, 8, _hoisted_37)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn px-3",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deletesnapshotDerecha()))
                      }, _hoisted_44)
                    ]))
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createVNode(_component_Field, {
            name: "izquierda",
            modelValue: _ctx.formData.izquierda,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.izquierda) = $event))
          }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("div", _hoisted_47, [
                (!_ctx.formData.izquierda && _ctx.cameraIzquierda)
                  ? (_openBlock(), _createBlock(_component_camera, {
                      key: 0,
                      resolution: { width: 300, height: 300 },
                      autoplay: "",
                      ref: "camera"
                    }, null, 512))
                  : (_ctx.formData.izquierda)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _ctx.formData.izquierda,
                        class: "img-fluid img-thumbnail cuadrado",
                        width: "250",
                        height: "250",
                        alt: "izquierdo"
                      }, null, 8, _hoisted_48))
                    : (_openBlock(), _createElementBlock("img", _mergeProps({ key: 2 }, field, {
                        src: _imports_0,
                        class: "img-fluid img-thumbnail cuadrado",
                        width: "250",
                        height: "250",
                        alt: "without_image"
                      }), null, 16)),
                _createVNode(_component_ErrorMessage, {
                  name: "izquierda",
                  class: "fv-plugins-message-container invalid-feedback"
                }),
                (_ctx.formData.frente && _ctx.formData.derecha && !_ctx.cameraIzquierda)
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 3,
                      type: "file",
                      accept: "image/*",
                      onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onFileChangeIzquierda && _ctx.onFileChangeIzquierda(...args)))
                    }, null, 32))
                  : _createCommentVNode("", true),
                (!_ctx.formData.izquierda)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      (!_ctx.cameraIzquierda)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn px-3",
                            disabled: _ctx.formData.frente && !_ctx.formData.derecha,
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openCameraIzquierda()))
                          }, _hoisted_53, 8, _hoisted_50))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn px-3",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openCameraIzquierda()))
                          }, _hoisted_56)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn px-3",
                        disabled: !_ctx.cameraIzquierda,
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.snapshot()))
                      }, _hoisted_60, 8, _hoisted_57)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn px-3",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.deletesnapshotIzquierda()))
                      }, _hoisted_64)
                    ]))
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}